import { useEffect, useState } from "react";
import { setAppTheme } from "../Settings/appTheme";
import type { PriceDisplayMode } from "../../utils/eventPricingUtils";

export function useMCStates() {

    const [appSection, setAppSection] = useState('tournaments');
    const [viewPanel, setViewPanel] = useState('snapshot');
    const [factor, setFactor] = useState(1);
    const [appTheme, setTheme] = useState(setAppTheme(factor));

    const [eventData, setEventData] = useState<any[]>([]);
    const [viewEvent, setViewEvent] = useState<any>(null);
    const [viewEventData, setViewEventData] = useState<any>([]);

    const [editMode, setEditMode] = useState(false);
    const [eventTab, setEventTab] = useState('details');
    const [eventTabValue, setEventTabValue] = useState(0);
    const [roundTab, setRoundTab] = useState('details');
    const [roundTabValue, setRoundTabValue] = useState(0);
    const [roundValue, setRoundValue] = useState(1);

    const [optionsLoaded, setOptionsLoaded] = useState<any[]>([]);

    const [redirectURL, setRedirectURL] = useState<string | null>(null);
    const [imageCache, setImageCache] = useState<{ [key: string]: string }>({});

    const [cartItems, setCartItems] = useState<any[]>([]);
    const [userRegistrations, setUserRegistrations] = useState<any[]>([]);
    const [userData, setUserData] = useState<any>(null);

    const [forceUpdate, setForceUpdate] = useState(false);

    const [priceDisplayMode, setPriceDisplayMode] = useState<PriceDisplayMode>('total');

    const [windowSize, setWindowSize] = useState({
        width: window.innerWidth,
        height: window.innerHeight,
        landscape: window.innerWidth > window.innerHeight,
        verticalMobile: window.innerWidth < window.innerHeight && window.innerWidth < 450,
        horizontalMobile: window.innerWidth < window.innerHeight && window.innerHeight < 450,
        verticalPC: window.innerWidth < window.innerHeight && window.innerWidth <= 600 ? "small" : 
            window.innerWidth < window.innerHeight && window.innerWidth <= 900 ? "medium" : 
            window.innerWidth < window.innerHeight ? "large" : "none",
        horizontalPC: window.innerWidth > window.innerHeight && window.innerWidth < 900 ? "small" : 
            window.innerWidth > window.innerHeight && window.innerWidth <= 1200 ? "medium" : 
            window.innerWidth > window.innerHeight ? "large" : "none",
        isMobile: /Mobi|Android|iPhone|iPad|iPod|tablet|Tab/i.test(navigator.userAgent),
        platform: navigator.userAgent,
        appBarHeight: document.getElementById('moment-central-header-ab')?.clientHeight || 80
    });

    useEffect(() => {
        console.log('App Bar Height', windowSize.appBarHeight);    
    }, [windowSize.appBarHeight]);

    const handleResize = () => {
        const newWindowSize = {
          width: window.innerWidth,
          height: window.innerHeight,
          landscape: window.innerWidth > window.innerHeight,
          verticalMobile: window.innerWidth < window.innerHeight && window.innerWidth < 450,
          horizontalMobile: window.innerWidth < window.innerHeight && window.innerHeight < 450,
          verticalPC: window.innerWidth < window.innerHeight && window.innerWidth <= 600 ? "small" : 
              window.innerWidth < window.innerHeight && window.innerWidth <= 900 ? "medium" : 
              window.innerWidth < window.innerHeight ? "large" : "none",
          horizontalPC: window.innerWidth > window.innerHeight && window.innerWidth < 900 ? "small" : 
              window.innerWidth > window.innerHeight && window.innerWidth <= 1200 ? "medium" : 
              window.innerWidth > window.innerHeight ? "large" : "none",
          isMobile: /Mobi|Android|iPhone|iPad|iPod|tablet|Tab/i.test(navigator.userAgent),
          appBarHeight: document.getElementById('moment-central-header-ab')?.clientHeight || 80
        }
    
        setWindowSize((prev: any) => ({ ...prev, ...newWindowSize }));
    };
    
    useEffect(() => {

        window.addEventListener('resize', handleResize);

        handleResize();

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    useEffect(() => {
        handleResize();
    }, [factor]);
    

    return {
        appSection, setAppSection,
        viewPanel, setViewPanel,
        factor, setFactor,
        appTheme, setTheme,
        eventData, setEventData,
        viewEvent, setViewEvent,
        viewEventData, setViewEventData,
        editMode, setEditMode,
        eventTab, setEventTab,
        eventTabValue, setEventTabValue,
        roundTab, setRoundTab,
        roundTabValue, setRoundTabValue,
        roundValue, setRoundValue,
        optionsLoaded, setOptionsLoaded,
        forceUpdate, setForceUpdate,
        redirectURL, setRedirectURL,
        imageCache, setImageCache,
        cartItems, setCartItems,
        userRegistrations, setUserRegistrations,
        userData, setUserData,
        windowSize, setWindowSize,
        priceDisplayMode, setPriceDisplayMode,
    }
}